import React from 'react'
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb'
import EditProfileForm from '../../../Components/Forms/EditProfileForm'

function EditProfile() {
  return (
    <>
      <Breadcrumb data="Edit Profile" />
      <div className="content-body">
        <div className='table-data'>
          <EditProfileForm />
        </div>
      </div>
    </>
  )
}

export default EditProfile
